export default __webpack_public_path__ + "static/media/nav_share.af6d141a.svg";